// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1782293200680
      var cssReload = require("D:/crecWork/vscode/crec-yitihua/workplat-pc/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  